module.exports = __webpack_public_path__ + "img/GW.b2149236.svg";